/* eslint-disable camelcase */
import React from 'react'
import { func, object, string } from 'prop-types'
import { EMPTY_OBJECT } from '../../../utils/constants'
import Image from '../../ui/image/Image'
import AdLink from '../../ui/ad-link/AdLink'
import Insights from '../Insights'
import { FormattedMessage } from 'react-intl'

const SponsoredContent = ({
  insights = EMPTY_OBJECT,
  item = EMPTY_OBJECT,
  classes,
  handleLinkClick
}) => {
  const { url, title, image, logo } = item
  const parsedUrl = new URL(url)
  parsedUrl.searchParams.append('utm_source', 'archdaily.com')
  const urlWithUTM = parsedUrl.toString()

  return (
    <Insights className={`gridview__item ${classes}`} {...insights}>
      <div className='gridview__image-wrapper'>
        <AdLink href={urlWithUTM} onClick={handleLinkClick} isBlank>
          <Image src={image} data-object-fit='cover' alt={title} />

          {logo && <img className='sponsored-logo' src={logo} alt={title} />}
        </AdLink>
      </div>
      <AdLink href={urlWithUTM} onClick={handleLinkClick} className='gridview__content' isBlank>
        <div className='gridview__text'>
          <p className='gridview__entry-category'>
            <FormattedMessage id='components.objects.sponsored' defaultMessage='Sponsored' />
          </p>
        </div>
        <h3 className='gridview__entry-title'>{title} <hd-icon class='external-link' svg='externalLink2' /></h3>
      </AdLink>
    </Insights>
  )
}

SponsoredContent.propTypes = {
  handleLinkClick: func,
  item: object,
  insights: object,
  classes: string
}

export default React.memo(SponsoredContent)
